
import React from "react";

interface WebsiteAnalysisHeaderProps {
  title: string;
  description: string;
}

const WebsiteAnalysisHeader: React.FC<WebsiteAnalysisHeaderProps> = ({ title, description }) => {
  return (
    <div>
      <h3 className="text-lg font-medium mb-1">{title}</h3>
      <p className="text-sm text-muted-foreground max-w-lg">
        {description}
      </p>
    </div>
  );
};

export default WebsiteAnalysisHeader;
